// extracted by mini-css-extract-plugin
export default {"list":"dh5miXBEDd_pdp"};